export function getHeadingClasses(level: number): string {
  switch (level) {
    case 1:
      return "text-4xl font-header !mt-8 !mb-4 first:!mt-0"
    case 2:
      return "text-3xl font-header !mt-8 !mb-4 first:!mt-0"
    case 3:
      return "text-2xl font-header !mt-6 !mb-4 first:!mt-0"
    case 4:
      return "text-xl font-header !mt-6 !mb-3 first:!mt-0"
    case 5:
      return "text-lg font-header !mt-6 !mb-3 first:!mt-0" // Added classes for h5
    default:
      // Defaulting to h1 style as per your renderer's default case
      return "text-4xl font-header !mt-8 !mb-4 first:!mt-0"
  }
}
